import { makeStyles } from "@material-ui/core/styles";
import * as Constants from "../../consts/Constants.js";

const style = makeStyles((theme) => ({

  item: {
    top: "0px",
    width: "358px",
    justifyContent: "space-between",
  },

  itemHeader: {
    paddingLeft: "30px",
    height: "40px",
    display: "flex",
    width: "100%",
    alignItems: "center",
    backgroundColor: Constants.COLOR_PRIMARY
  },

  itemContent: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },

  itemFooter: {
    display: "flex",
    paddingBottom: "10px",
    alignItems: "center",
    justifyContent: "center",
  },

  titleInitial: {
    fontWeight: "bold",
    fontSize: "18px",
    color: "white",
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
 
 box: {
    display: "flex",
    flexFlow: "column",
    height: "100%"
  },

  rowHeader: {
    flex: "0 1 auto"
    /* The above is shorthand for:
    flex-grow: 0,
    flex-shrink: 1,
    flex-basis: auto
    */
  },

  rowContent: {
    flex: "1 1 auto"
  },

  rowFooter: {
    flex: "0 1 40px"
  }

}));

export default style;
